import {Mapper} from '@s-ui/domain'

export class SeoStaticMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
    this._defaultCanonical = ''
  }

  async map({pageName, culture}) {
    const {TITLE, META_DESCRIPTION, META_ROBOTS} = this._config.get('seo').staticSections[pageName][culture] || {}

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(TITLE)
      .description(META_DESCRIPTION)
      .robots(META_ROBOTS)
      .canonical(this._defaultCanonical)
      .setOpenGraphData({
        title: TITLE,
        description: META_DESCRIPTION,
        url: this._defaultCanonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
